import * as ko from 'knockout'
import template from './trot.starter.tpl.html'
import { Params, TrotStarterViewModel } from './TrotStarterViewModel'

if (!ko.components.isRegistered('trot-starter')) {
  ko.components.register('trot-starter', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new TrotStarterViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
